/**
 * Hesapsız kişinin (personel kartı, giriş hesabı yok) adresi (ADR 0131 Ek 1). `users.email` boş
 * olamaz (gemi SQLite'ında tablo yeniden kurulmaz); kişiye RFC 2606 §2'nin ayrılmış `.invalid` üst
 * alan adında ulaşılamaz, tekil bir adres verilir. Giriş akışları bu alan adını açıkça reddeder,
 * arayüz adresi göstermez, Settings ▸ Users bu kişileri listelemez. Emsal: `releasedEmail`
 * (`<id>@released.invalid`, ADR 0042 §23).
 */
export const NO_LOGIN_EMAIL_DOMAIN = 'no-login.invalid';

/** Kişi kimliğinden adres: `crew-<userId>@no-login.invalid`. */
export function noLoginEmail(userId: string): string {
  return `crew-${userId.trim().toLowerCase()}@${NO_LOGIN_EMAIL_DOMAIN}`;
}

/** Adres hesapsız kişinin yer tutucusu mu (büyük-küçük harf ve kenar boşluğundan bağımsız). */
export function isNoLoginEmail(email: string | null | undefined): boolean {
  if (typeof email !== 'string') return false;
  return email.trim().toLowerCase().endsWith(`@${NO_LOGIN_EMAIL_DOMAIN}`);
}
